import { useState } from "react";
import { PropTypes } from "prop-types";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import CopyCard from "components/Clipboard/CopyCard";
import OnetimePassword from "components/Auth/OnetimePassword";
import Lang from "components/Lang";

export const MfaRegistrarModal = ({ secretCode, username, submit, onExited, backdrop }) => {
  if (!secretCode) {
    return null;
  }
  const [code, setCode] = useState("");
  const [codeValid, setCodeValid] = useState("");
  const [visible, setVisible] = useState(true);
  const [failed, setFailed] = useState(false);

  const checkSubmittable = () => codeValid;
  const close = () => setVisible(false);
  const codeObserver = (result) => {
    setCode(result.code);
    setCodeValid(result.valid);
  };
  const submitHandler = (event) => {
    event.preventDefault();
    if (!checkSubmittable()) {
      return;
    }
    setFailed(false);
    submit(code)
      .then(close)
      .catch(() => setFailed(true));
  };
  return (
    <Modal
      className="modal-container"
      size="lg"
      show={visible}
      onHide={close}
      onExited={onExited}
      backdrop={backdrop || "static"}
      animation={true}
    >
      <Form onSubmit={submitHandler}>
        <Modal.Header closeButton>
          <div className="h6 mb-0"><Lang>2要素認証のセットアップ</Lang>: {username}</div>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <p><Lang>1. MFA(多要素認証)用のワンタイムパスワードアプリを用意してください。</Lang></p>
          </div>
          <div className="mb-4">
            <p><Lang>2. アプリから以下のQRコードを読み取るか、文字列をセットアップキーとして入力してください。</Lang></p>
            <div className="text-center">
              <div>
                <QRCodeCanvas value={`otpauth://totp/${username}?issuer=WonderOrder&secret=${secretCode}`} />
              </div>
              <div>
                <CopyCard value={secretCode} />
              </div>
            </div>
          </div>
          <div className="mb-4">
            <p><Lang>3. アプリに表示されているワンタイムパスワードを入力してください。</Lang></p>
            {Boolean(failed) && (
              <Alert variant="warning">
                <p className="mb-0"><Lang>登録に失敗しました。新しいワンタイムパスワードでやり直してください。</Lang></p>
              </Alert>
            )}
            <OnetimePassword observer={codeObserver}/>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={close}>
            <Lang>キャンセル</Lang>
          </Button>
          <Button variant="primary" type="submit" disabled={!checkSubmittable()}>
            <Lang>登録</Lang>
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
MfaRegistrarModal.propTypes = {
  submit:   PropTypes.func.isRequired,
  backdrop: PropTypes.string,
  onExited: PropTypes.func
};